import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { PaymentState } from '../../ngrx/reducers/payment.reducer';
import { UtilitiesProvider } from '../../providers/utilities';
import { ENV } from '@app/env';
import * as fromPayment from '../../ngrx/reducers/payment.reducer';
import * as paymentActions from '../../ngrx/actions/payment.actions';
import { PaymentProvider } from '../../providers/payment';
import { CouponData } from '../../providers/coupon';
import { NavController } from 'ionic-angular/navigation/nav-controller';
import moment from 'moment';
import { AnalyticsData, _ACTIONS } from '../../providers/analytics';
import { toArray, has } from 'lodash';

const componentName = 'PayButtonTicketComponent';

@Component({
  selector: 'app-pay-button-ticket',
  templateUrl: 'pay-button-ticket.component.html'
})

export class PayButtonTicketComponent implements OnInit, OnChanges {

  @Input() uidTrack: string;
  @Input() config: any;
  @Input() shoppingCart: any;
  @Input() buttonLabel = null;
  @Input() user: any;
  @Output() onPay = new EventEmitter();
  @Output() sendDefaultCard = new EventEmitter();

  public paymentState$: Observable<PaymentState>;
  public defaultCard;
  public provider = ENV.payment_provider;
  public buttonDisabled: boolean = true;
  public clientId = ENV.client;

  constructor(
    private store: Store<any>,
    private navCtrl: NavController,
    private paymentProvider: PaymentProvider,
    private couponProvider: CouponData,
    private utilities: UtilitiesProvider,
    private analytics: AnalyticsData,
  ) { }

  ngOnInit() {
    if (!this.isExternalPay) {
      this.store.dispatch(new paymentActions.GetCards());
      this.paymentState$ = this.store.select(fromPayment.getPaymentState)
        .do(state => {
          this.getDefaultCardData(state);
          if (state.error && !state.loading) {
            this.buttonDisabled = state.error.error.message;
            this.paymentProvider.registerTransactionLog('List card error pay button', state.error, this.user.info.id)
          } else {
            this.buttonDisabled = false;
          }
        });
    } else {
      this.defaultCard = true;
      // Se emite la nueva tarjeta
      this.sendDefaultCard.emit(this.defaultCard);
    }
  }

  /**
   * Visualiza metodos de pago, metodo que se usa cuando no hay TC
   * @author Juan Pablo C Mejia <jcardona@ideabti.com>
   * Revisión: 28-08-2018
   */
  public viewPaymentMethods() {
    // if (this.buttonDisabled) {
    //   this.utilities.toast.create({
    //     message: `${this.buttonDisabled}`,
    //     duration: 3000,
    //     position: 'button'
    //   }).present();
    // } else {
      this.navCtrl.push('PaymentMethodsPage');
    // }
  }

  /**
   * Explora cambios Inputs del componente
   * @param changes
   * @author Juan Pablo C Mejia <jcardona@ideabti.com>
   * Revisión: 28-08-2018
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.config) this.config = changes.config.currentValue;
    if (changes.shoppingCartPage) this.shoppingCart = changes.shoppingCartPage.currentValue;
    if (changes.buttonLabel) this.buttonLabel = changes.buttonLabel.currentValue;
  }

  /**
   * Retorna la tarjeta de credito por defecto
   * @param paymentState
   * @author Juan Pablo C Mejia <jcardona@ideabti.com>
   * Revisión: 28-08-2018
   */
  private getDefaultCardData(paymentState: PaymentState) {
    let def = null;
    if (paymentState.default && paymentState.cards.length > 0) {
      def = paymentState.cards.find(el => el.token === paymentState.default);
      if (!def) def = null;
    } else if (!paymentState.default) {
      def = paymentState.cards[0];
    } else {
      def = null;
    }
    this.defaultCard = def;
    // Se emite la nueva tarjeta
    this.sendDefaultCard.emit(this.defaultCard);
  }

  /**
   * Abre modal para selecciona un nuevo metodo de pago
   * @author Juan Pablo C Mejia <jcardona@ideabti.com>
   * Revisión: 28-08-2018
   */
  public selectPayMethod() {
    const modal = this.utilities.modal.create('SelectPaymentMethodPage');
    modal.present();
    modal.onDidDismiss((data) => {
      if (data) {
        this.defaultCard = data;
        // Se emite la nueva tarjeta
        this.sendDefaultCard.emit(this.defaultCard);
      }
    });
  }

  /**
   * Emite proceso de pago
   *
   * @author Juan Pablo C Mejia <jcardona@ideabti.com>
   * Revisión: 28-08-2018
   */
  public pay() {
    let tokenCard = null;
    if (!this.isExternalPay) {
      tokenCard = has(this.defaultCard, "token") ? this.defaultCard.token : null;
    }
    return this.onPay.emit({ token: tokenCard, number: has(this.defaultCard, "number") ? this.defaultCard.number : null });
  }

  /**
   * Este metodo valida si se muestran las opciones de administrar los metodos de pago del usuario
   * Aplica para pago PSE, payu o cualquier pasarela que no tiene tokenizacion de tarjetas de credito
   */
  public isPaymentMethods() {
    return this.utilities.isPaymentMethods;
  }

  /**
   * Se valida si el boton de pago se habilita o no
   */
  public get isExternalPay() {
    switch (ENV.payment_provider) {
      case 'payu':
      case 'fake':
        return true;
      case 'paymentez':
      case 'payu_gateway':
        return false;
    }
  }

  public async removeCurrentCoupon() {
    if (this.shoppingCart.coupon) {
      this.utilities.alert.create({
        title: await this.utilities.translateTextOrObject('Discount code'),
        message: await this.utilities.translateTextOrObject('Do you want to delete the applied coupon?'),
        buttons: [{
          text: await this.utilities.translateTextOrObject('Cancel'),
          role: 'cancel'
        }, {
          text: await this.utilities.translateTextOrObject('Confirm'),
          handler: () => {
            let load = this.utilities.setLoading();
            this.shoppingCart.coupon = null;
            this.paymentProvider.applyDiscountTicket(this.shoppingCart, this.user.info.id)
              .then(() => load.dismiss())
              .then(() => this.presentToast('The discount has been delete correctly!'));
          }
        }]
      }).present();
    }
  }
  /**
   * Procesom para adicionar un codigo de descuento
   */
  public async addPromoCode() {
    this.utilities.alert.create({
      title: await this.utilities.translateTextOrObject('Discount code'),
      message: await this.utilities.translateTextOrObject('Enter your discount code'),
      inputs: [{
        type: 'text',
        label: await this.utilities.translateTextOrObject('Discount code'),
        name: 'code'
      }],
      buttons: [{
        text: await this.utilities.translateTextOrObject('Cancel'),
        role: 'cancel'
      }, {
        text: await this.utilities.translateTextOrObject('Ok'),
        role: 'cancel',
        handler: (data) => {
          if (data.code) {
            this.utilities.consoleDecorator('Input: ', data.code);
            this.validatePromoCodeToAdd(data.code);
          } else {
            return false;
          }
        }
      }]
    }).present();
  }

  /**
   * Valida y aproba la validez del codigo
   * 1. Se valida si ya tiene un descuento aplicado
   * @param code
   */
  private async validatePromoCodeToAdd(code: string) {
    if (this.shoppingCart.apply_discount) { return this.presentAlert('Only one discount per purchase is allowed!'); }

    const load = this.utilities.setLoading();
    const coupon = await this.couponProvider.getCouponByCodeRef(code)
      .then(coupons => {
        if (coupons) {
          if (Object.keys(coupons).length > 0) {
            const key = Object.keys(coupons)[0];
            return coupons[key];
          }
        }
        return null;
      })
      .then(cp => this.handleCouponValidationBasic(cp, code))
      .then(cp => this.handleCouponApply(cp));

    if (!coupon) {
      load.dismiss();
      return false;
    } else {
      this.shoppingCart.coupon = coupon;
      return this.paymentProvider.applyDiscountTicket(this.shoppingCart, this.user.info.id)
        .then(() => load.dismiss())
        .then(() => this.presentToast('The discount has been applied correctly!'))
        .then(() => this.analytics.savePageTrackOnFirestore(
          componentName,
          _ACTIONS.applyDiscountCode,
          this.uidTrack,
          { code, shoppingCart: this.shoppingCart }
        ));
    }
  }

  /**
   * Se hace validacion avanzada
   * 1. se valida que el cupon haya pasado las validaciones basicas
   * @param coupon
   * @param code
   */
  private handleCouponApply(evalCoupon: any) {
    let flagCoupon = false;
    if (evalCoupon) {
      Object.keys(evalCoupon.objects).map(keyCoupon => {
        Object.keys(this.shoppingCart.tickets).map(keyTicket => {
          if (this.shoppingCart.tickets[keyTicket].id === evalCoupon.objects[keyCoupon].id) {
            flagCoupon = true;
          }
        });
      });
      if (!flagCoupon) {
        this.utilities.consoleDecorator('12', evalCoupon);
        this.presentAlert('The entered code is invalid!');
      }
      return flagCoupon ? evalCoupon : 0;
    } else {
      // this.presentAlert('The entered code is invalid!');
      return false;
    }
  }

  /**
   * Validacion basica del coupon
   * @param evalCoupon
   * @param code
   */
  private handleCouponValidationBasic(evalCoupon: any, code: string) {
    if (evalCoupon) {
      if (!evalCoupon.state) {
        this.utilities.consoleDecorator('1', evalCoupon);
        this.presentAlert('The entered code is invalid!');
        return false;
      }

      if (evalCoupon.type_discount !== 'ticket') {
        this.utilities.consoleDecorator('2', evalCoupon);
        this.presentAlert('The entered code is invalid!');
        return false;
      }

      if (evalCoupon.expiration_date < moment().format()) {
        this.utilities.consoleDecorator('3', evalCoupon);
        this.presentAlert('The code entered is expired!');
        return false;
      }

      if (evalCoupon.objects_type_pay !== 'app') {
        this.utilities.consoleDecorator('4', evalCoupon);
        this.presentAlert('The coupon can only be used for physical payment, please go to an authorized discount point!');
        return false;
      }

      if (evalCoupon.privacy === 'private') {
        if (!this.user.info.profile) {
          this.utilities.consoleDecorator('5', evalCoupon);
          this.presentAlert('The entered code is invalid!');
          return false;
        }

        if (!evalCoupon.profiles_view[this.user.info.profile]) {
          this.utilities.consoleDecorator('6', evalCoupon);
          this.presentAlert('The entered code is invalid!');
          return false;
        }
      }

      if (evalCoupon.type_coupon === 'code') {
        if (evalCoupon.quota >= evalCoupon.used_quota) {
          this.utilities.consoleDecorator('7', evalCoupon);
          this.presentAlert('The coupon entered is no longer available!');
          return false;
        }
        return this.couponProvider.getCouponUserByIdRef(evalCoupon.id, this.user.info.id)
          .then(couponUser => {
            if (couponUser) {
              if (couponUser.redeemed) {
                this.utilities.consoleDecorator('7.1', evalCoupon);
                this.presentAlert('The coupon entered has already been redeemed!');
                return false;
              }
            }
            return evalCoupon;
          });
      } else if (evalCoupon.type_coupon === 'coupon') {
        return this.couponProvider.getCouponUserByCodeRef(code, this.user.info.id)
          .then(couponsUser => {
            couponsUser = toArray(couponsUser);
            if (couponsUser.length > 0) {
              const evalCouponUser = couponsUser[0];
              if (evalCouponUser.redeemed) {
                this.utilities.consoleDecorator('8', evalCoupon);
                this.presentAlert('The coupon entered has already been redeemed!');
                return false;
              } else {
                return evalCoupon;
              }
            } else {
              this.utilities.consoleDecorator('9', evalCoupon);
              this.presentAlert('The entered code is invalid!');
              return false;
            }
          })
      } else {
        this.utilities.consoleDecorator('10', evalCoupon);
        this.presentAlert('An error has occurred when trying to enter the coupon');
        return false;
      }
    } else {
      this.utilities.consoleDecorator('11', evalCoupon);
      this.presentAlert('The entered code has not been found!');
      return false;
    }
  }

  /**
   * Presenta mensaje tipo Alert
   * @param message
   * @param title
   */
  private presentAlert(message: string, title: string = 'Alert') {
    return this.utilities.presentAlert(
      title,
      message,
      [{
        text: 'Ok',
        role: 'cancel'
      }]
    );
  }


  /**
   * Create and present a toast with custom message and default values
   * @param message toast message
   * @param duration toast duration in milliseconds
   * @param position toast position
   * @author Jhonny Martínez
   */
  private presentToast(msg: string, duration = 5000, position = 'top') {
    this.utilities.setToast(msg, duration, position);
  }
}



// WEBPACK FOOTER //
// ./src/components/pay-button-ticket/pay-button-ticket.component.ts